<template>
  <v-dialog v-model="show" width="500">
    <v-card>
      <v-card-title>
        <span class="headline">添付資料アップロード</span>
      </v-card-title>
      <v-card-text>
        <v-container fluid style="padding:0px 18px !important;">
          <v-layout row wrap>
            <!-- <v-radio-group column v-model="category">
              <v-radio label="INV P/L" value="invoice"></v-radio>
              <v-radio label="B/L" value="bl"></v-radio>
              <v-radio label="S/A" value="sa"></v-radio>
              <v-radio label="A/N" value="an"></v-radio>
            </v-radio-group>-->
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <file-upload :businessKey="id" :domain="'ar'" category="ar" title="Upload"></file-upload>
        <v-btn @click="show = false" class="ml-4">{{$t('app.buttons.back')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ['blNo'],
  data() {
    return {
      show: false,
      category: 'ar',
      resolve: null,
      reject: null,
      id: null
    }
  },
  methods: {
    popup(id) {
      this.id = id
      this.show = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    }
  }
}
</script>
